import { Grid, IconButton, Tooltip } from "@mui/material";
import React from "react";
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { toast } from 'lib.front';

interface CopyInfoProps {
    info: string;
    color: string;
}

export const CopyInfo: React.FC<CopyInfoProps> = ({ info, color }) => {
    const handleCopyToClipboard = (text: string) => {
        navigator.clipboard
            .writeText(text)
            .then(() => toast.showSucces('Se copió correctamente.'))
            .catch(err => toast.showError('No se pudo copiar el texto: ' + err));
    }
    return (
        <Grid container spacing={1}>
            <Grid item xs={10} style={{ color: color, alignContent: 'center' }}>
                {info}
            </Grid>
            <Grid item xs={2} style={{ alignContent: 'center' }}>
                <Tooltip title="Copiar" >
                    <IconButton onClick={() => handleCopyToClipboard(info)} size="large">
                        <FileCopyOutlinedIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    )
}